import { useTranslation } from 'react-i18next';
import { Typography } from '@kizen/kds/Typography';

import Modal from 'components/Modals/presets/BasicModal';

export const DowngradeCancellationDialog = (props: any) => {
  const { t } = useTranslation();

  return (
    <Modal
      {...props}
      heading={t('Confirm Plan Downgrade Cancellation')}
      buttonText={t('Confirm')}
    >
      <div className="pb-2">
        <Typography>
          {t(
            'Please Confirm the cancellation of the upcoming plan downgrade. The business will remain on the current plan.'
          )}
        </Typography>
      </div>
    </Modal>
  );
};
